export default function AzureADLogin() {
  return (
    <div className="header-container flex-row-align">
      <div className="flex-row space-evenly align-items w-100 ptb-1">
        <div>
          <h1 className="text-lg font-semibold">Saxifraga</h1>
          <p>Welcome to your adminpanel 🎉</p>
        </div>
        <div className="logout flex-row-align">
          <a className="btn btn-second-color" href="/.auth/login/aad">
            log in
          </a>
        </div>
      </div>
    </div>
  );
}
